import type { PropsWithChildren } from "react";

import { SWReactIcons } from "@similarweb/icons";
import { Flex } from "@similarweb/ui-components/foundations";

import { generateAutomationName } from "../../../../helpers/generateAutomationName";
import { MainCompetitor } from "../MainCompetitor/MainCompetitor";
import {
    EditSettingsDeleteButtonWrapper,
    EditSettingsMainCompetitorContentWrapper,
    EditSettingsMainCompetitorWrapper,
} from "../styles";

import type { SettingsMainCompetitorSchema } from "./type";

export const SettingsMainCompetitor = ({
    name,
    image,
    isDisabled,
    isActive,
    onSelect,
    onDelete,
    children,
}: PropsWithChildren<SettingsMainCompetitorSchema>) => (
    <EditSettingsMainCompetitorWrapper
        data-automation={generateAutomationName("settings", ["competitors", "main", "wrapper"])}
    >
        <EditSettingsMainCompetitorContentWrapper>
            <Flex
                gap="16px"
                alignItems="center"
            >
                <MainCompetitor
                    name={name}
                    image={image}
                    onClick={onSelect}
                    disabled={isDisabled}
                    isActive={isActive}
                    isTooltipEnabled={isDisabled}
                />
                {children}
            </Flex>
            <EditSettingsDeleteButtonWrapper
                data-automation={generateAutomationName("settings", ["competitors", "main", "delete", "button", name])}
                onClick={onDelete}
            >
                {!isDisabled ? (
                    <SWReactIcons
                        iconName="delete"
                        size="sm"
                    />
                ) : null}
            </EditSettingsDeleteButtonWrapper>
        </EditSettingsMainCompetitorContentWrapper>
    </EditSettingsMainCompetitorWrapper>
);
